import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { ChevronDown } from 'BreetAssets';
import { memo, type RefObject } from 'react';

import { DropdownWrapper } from '../../Dropdown';
import type { IFiatDropDownOption, IFiatDropDownProps } from '../FiatInput.helpers';

const FiatDropDown = memo(({ defaultOption, selectedOption, options, onSelect, isLoading }: IFiatDropDownProps) => (
	<div className='fiat-drop-down-wrapper'>
		<DropdownWrapper>
			{({ controlRef, dropdownRef, handleVisibility, visible }) => {
				const handleSelect = (option: IFiatDropDownOption) => () => {
					onSelect?.(option);
					handleVisibility();
				};

				return (
					<>
						<Button
							variant='native'
							className='tooltip'
							onClick={handleVisibility}
							type='button'
							ref={controlRef as RefObject<HTMLButtonElement>}
						>
							<div className='fiat_input-dropdown'>
								<div className='left'>
									{selectedOption?.icon ?? defaultOption?.icon}
									<Typography className='color-primary-50 truncate'>{selectedOption?.label ?? defaultOption?.label}</Typography>
								</div>

								{isLoading ? (
									<span className='global-skeleton'>loa</span>
								) : (
									<ChevronDown className={classNameMerger('select-chevron-down', visible && 'rotated')} />
								)}
							</div>
						</Button>
						{visible && (
							<div
								className='bg-primary-400 border-primary-400 dropdownshadow options-wrapper scrollbar'
								ref={dropdownRef}
							>
								{options.map((option) => (
									<Button
										key={option.label}
										variant='native'
										label={option.label}
										onClick={handleSelect(option)}
										leadingIcon={<span className='icon'>{option.icon}</span>}
										className='color-primary-50 bg-primary-400 bg-primary-500-hover'
									/>
								))}
							</div>
						)}
					</>
				);
			}}
		</DropdownWrapper>
	</div>
));

FiatDropDown.displayName = 'FiatDropDown';

export default FiatDropDown;
